import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id E06EE7FD-6CC5-4BB4-9B00-1397D6E18DDF
 * name youtube-subscription
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/youtube-subscription.svg
 * tags
 * - Brand / Logo 
 */
export const YoutubeSubscriptionIcon = createSvgIcon(<><path d="M20,8H4V6H20V8M18,2H6V4H18V2M22,12V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V12A2,2 0 0,1 4,10H20A2,2 0 0,1 22,12M16,16L10,12.73V19.26L16,16Z" /></>, 'YoutubeSubscriptionIcon');
export default YoutubeSubscriptionIcon